import { vehicleTypeMessages } from "@slfinrtl/ui-bff-routes"
import type { DataSource } from "@slfinrtl/ui-bff-routes"
import type { IntlShape } from "react-intl"
import { pricingFieldMessages } from "../hooks/pricingField.messages"
import type { ExtraCostsPriceBreakdownPricingFields } from "./extraCostsPriceBreakdownPricing.fields"
import { extraCostsPricingFieldNames } from "./extraCostsPriceBreakdownPricing.fields"

export const getExtraCostsPriceBreakdownPricingFields = ({
	dataSource,
	editListingPriceNewCars,
	formatMessage,
	isDraft,
	isNewCar,
	vatDeductibleAvailable,
}: {
	dataSource: DataSource | undefined
	editListingPriceNewCars: boolean
	formatMessage: IntlShape["formatMessage"]
	isDraft: boolean
	isNewCar: boolean
	vatDeductibleAvailable: boolean
}): ExtraCostsPriceBreakdownPricingFields => {
	const priceDisabledHint =
		!editListingPriceNewCars && dataSource === "PVMS"
			? formatMessage(pricingFieldMessages.editPriceDisabledForUSPVMSVehicles)
			: undefined

	return {
		extraCosts: {
			name: extraCostsPricingFieldNames.extraCostsName,
		},
		extraCostsVehicleType: {
			name: extraCostsPricingFieldNames.extraCostsVehicleTypeName,
		},
		minimumPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: extraCostsPricingFieldNames.minimumPriceName,
			type: "currency",
		},
		purchasePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: extraCostsPricingFieldNames.purchasePriceName,
			type: "currency",
		},
		vatDeductible: vatDeductibleAvailable
			? {
					disabledHint: isNewCar
						? formatMessage(pricingFieldMessages.notPossibleToEditVatDeductible, {
								vehicleType: formatMessage(vehicleTypeMessages.NEW_CAR),
							})
						: undefined,
					label: formatMessage(pricingFieldMessages.vatDeductibleLabel),
					name: extraCostsPricingFieldNames.vatDeductibleName,
				}
			: undefined,
		vehiclePrice: {
			debounced: isDraft ? 500 : undefined,
			disabledHint: priceDisabledHint,
			label: formatMessage(
				vatDeductibleAvailable
					? pricingFieldMessages.vehicleGrossPriceLabel
					: pricingFieldMessages.vehiclePriceLabel,
			),
			maxLength: 15,
			name: extraCostsPricingFieldNames.vehiclePriceName,
			required: !priceDisabledHint,
			type: "currency",
		},
	}
}
